import omit from 'lodash/omit';
import React, { Component } from 'react';
import PropTypes from 'prop-types';

export default class Link extends Component {
    static propTypes = {
        onClick: PropTypes.func.isRequired,
    };

    onClick = e => {
        this.props.onClick();
        e.preventDefault();
    };

    render() {
        return (
            // eslint-disable-next-line jsx-a11y/anchor-has-content, jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
            <a {...omit(this.props, 'onClick')} onClick={this.onClick} />
        );
    }
}
